import { render, staticRenderFns } from "./RecipePageActionMenu.vue?vue&type=template&id=34c5766d&scoped=true&"
import script from "./RecipePageActionMenu.vue?vue&type=script&lang=js&"
export * from "./RecipePageActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./RecipePageActionMenu.vue?vue&type=style&index=0&id=34c5766d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5766d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar,VTooltip})
